"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isomorphicDompurify = require("isomorphic-dompurify");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var StyledWrapSpan = _styledComponents["default"].span.withConfig({
  displayName: "transformer__StyledWrapSpan",
  componentId: "sc-1ah16kv-0"
})(["display:inline-flex;"]);
var aprWrap = function aprWrap(text, match) {
  var _match = _slicedToArray(match, 1),
    fullMatch = _match[0];
  var parts = text.split(fullMatch);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, parts[0], /*#__PURE__*/_react["default"].createElement(StyledWrapSpan, null, fullMatch), parts[1]);
};
var symbols = function symbols(text) {
  var replacements = [{
    regex: /™/g,
    replacement: '<sup>™</sup>'
  }, {
    regex: /®/g,
    replacement: '<sup>®</sup>'
  }, {
    regex: /&trade;/gi,
    replacement: '<sup>&trade;</sup>'
  }, {
    regex: /&reg;/gi,
    replacement: '<sup>&reg;</sup>'
  }];
  return replacements.reduce(function (replacedText, _ref) {
    var regex = _ref.regex,
      replacement = _ref.replacement;
    return replacedText.replace(regex, replacement);
  }, text);
};
var transformer = function transformer(text) {
  if (!text) {
    return text;
  }
  var sanitizedText = (0, _isomorphicDompurify.sanitize)(text);

  // APR Wrap

  var aprPattern = /(\d+(\.\d+)?% [Aa][Pp][Rr])/;
  var aprMatch = text.match(aprPattern);
  if (aprMatch) {
    return aprWrap(text, aprMatch);
  }

  // Symbols
  return symbols(sanitizedText);
};
var _default = exports["default"] = transformer;